import React from 'react';

export const handleAvatarMerge = (avatars) =>
  avatars.map((avatarURL, idx) => {
    let styles;
    switch (idx) {
      case 1:
        styles = { top: 16, left: 20 };
        break;
      case 2:
        styles = { top: 19, left: 6 };
        break;
      case 3:
        styles = { top: -1, left: 21 };
        break;
      case 4:
        styles = { top: 13, left: -9 };
        break;
      default:
        styles = { left: 0 };
    }

    return (
      <span key={avatarURL + idx}>
        <img
          style={styles}
          className="mini-avatar"
          src={avatarURL}
          alt={`avatar-${idx}`}
        />
      </span>
    );
  });

export const parseNames = (nameList) => {
  if (nameList.length > 2) {
    const firstTwo = nameList.slice(0, 2);
    return firstTwo.join(', ') + ` + ${nameList.slice(2).length} more`
  }

  if (nameList.length > 1) {
    return nameList.join(' & ');
  }

  return nameList[0];
};

export const removeDuplicates = (list) => (
  list.filter((value, index) => {
    return (
      index ===
      list.findIndex((obj) => {
        return obj.id === value.id;
      })
    );
  })
);
